var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"base-answer"},[_c('div',{staticClass:"relative mx-auto",class:( _obj = {}, _obj[_vm.wrapClass] = _vm.wrapClass, _obj ),style:({ zIndex: _vm.zIndex }),attrs:{"data-order":_vm.order,"data-assist":_vm.disabled ? 'off' : 'focus'}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }